import { MODAL_NAMES } from 'common/activeElements/modals/modalNames';
import { SIDEBAR_NAMES } from 'common/activeElements/sidebars/sidebarsNames';

export const EMPLOYMENT_CONTROLS_TEXT = {
	buttonAriaLabel: 'Employment actions',
};

/** @type {Record<string, string>} */
export const EMPLOYMENT_ACTION_LABELS = {
	[MODAL_NAMES.employmentType]: 'Add employment change',
	[SIDEBAR_NAMES.employmentLog]: 'View employment history',
};
